import React from "react";

const ThermalPrintableArea: FCwC<{
  printableRef: React.Ref<HTMLDivElement>;
}> = ({ printableRef, children }) => {
  return (
    <div
      // Hack to make it visually invisible, but still renderable to an image.
      data-testid="printableAreaWrapper"
      style={{
        // When testing, set this to 100% to see what you're designing
        opacity: "0%",
        // Important to allow someone to click anything that is beneath it.
        pointerEvents: "none",
        // The following styles are only to assist with devving
        zIndex: 999999,
        position: "absolute",
        top: "30px",
        right: "30px",
        overflow: "hidden",
      }}
    >
      <div
        ref={printableRef}
        style={{
          backgroundColor: "white",
          // Spec for Epson 80mm paper is 72mm printable area. This just adds some buffer.
          width: "70mm",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default ThermalPrintableArea;
